import React from 'react';
import { EVENT_FILTERS, EVENT_LABELS, SOURCE_LABELS, dateText, fmt, num } from './helpers';
import {
  stdBadgeActive, stdBadgeMuted, stdTabBtn, stdTabGroup, stdTableWrap, stdTh,
} from '../adminlayout/designStandard';

export default function RevenueEventTable({ events, loading, selectedMonth, filter, onFilterChange, onOpenTravel }) {
  return (
    <section style={cardStyle}>
      <div style={sectionHead}>
        <h3 style={sectionTitle}>상세 이벤트 {selectedMonth ? `· ${selectedMonth}` : ''} · {fmt(events.length)}건</h3>
        {/* 상호배타 필터 — 표준 알약 탭 그룹 */}
        <div style={stdTabGroup}>
          {EVENT_FILTERS.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => onFilterChange(item.value)}
              style={stdTabBtn(filter === item.value)}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
      <div style={stdTableWrap}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th>반영일</Th>
              <Th>여행코드</Th>
              <Th>고객명</Th>
              <Th>유형</Th>
              <Th>출처</Th>
              <Th right>고객변화</Th>
              <Th right>고객환불</Th>
              <Th right>원가변화</Th>
              <Th right>공급사환불</Th>
              <Th right>취소수수료</Th>
              <Th right>추가원가</Th>
              <Th right>기타</Th>
              <Th right>수익</Th>
              <Th>메모</Th>
            </tr>
          </thead>
          <tbody>
            {events.length === 0 ? (
              <tr><td colSpan={14} style={emptyTd}>{loading ? '조회 중...' : '이벤트가 없습니다.'}</td></tr>
            ) : events.map((row, index) => {
              const last = index === events.length - 1; // 마지막 행 밑줄 제거 (표준)
              return (
              <tr key={row.id}>
                <Td last={last}>{dateText(row.event_date)}</Td>
                <Td last={last}>
                  {onOpenTravel ? (
                    <button type="button" onClick={() => onOpenTravel(row.travel_code)} style={linkBtn}>
                      {row.travel_code}
                    </button>
                  ) : (
                    row.travel_code
                  )}
                </Td>
                <Td last={last}>{row.customer_name || '-'}</Td>
                <Td last={last}>{EVENT_LABELS[row.event_type] || row.event_type}</Td>
                <Td last={last}><SourceBadge row={row} /></Td>
                <Td last={last} right danger={num(row.customer_amount) < 0}>{fmt(row.customer_amount)}</Td>
                <Td last={last} right>{fmt(row.customer_refund)}</Td>
                <Td last={last} right danger={num(row.total_cost) < 0}>{fmt(row.total_cost)}</Td>
                <Td last={last} right>{fmt(row.supplier_refund)}</Td>
                <Td last={last} right>{fmt(row.supplier_cancel_fee)}</Td>
                <Td last={last} right>{fmt(row.additional_cost)}</Td>
                <Td last={last} right danger={num(row.misc) < 0}>{fmt(row.misc)}</Td>
                <Td last={last} right strong danger={num(row.amount) < 0}>{fmt(row.amount)}</Td>
                <Td last={last}>{row.reservation_notes || '-'}</Td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function SourceBadge({ row }) {
  const hasItems = num(row.item_count) > 0;
  return (
    <span style={hasItems ? detailBadge : sourceBadge}>
      {hasItems ? '상세' : (SOURCE_LABELS[row.source] || row.source || '-')}
    </span>
  );
}

function Th({ children, right }) {
  return <th style={{ ...thStyle, textAlign: right ? 'right' : 'left' }}>{children}</th>;
}

function Td({ children, right, strong, danger, last }) {
  return (
    <td style={{
      ...tdStyle,
      ...(last ? { borderBottom: 'none' } : null),
      textAlign: right ? 'right' : 'left',
      fontWeight: strong ? 850 : 500,
      color: danger ? '#dc2626' : 'var(--text)',
    }}>
      {children}
    </td>
  );
}

// 디자인 표준: 섹션은 박스 없이(제목 행 + 표 카드), 표는 stdTableWrap + 검정 머리글 띠
const cardStyle = { display: 'grid', gap: 8 };
const sectionHead = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' };
const sectionTitle = { margin: 0, fontSize: 14, color: 'var(--text)' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', minWidth: 1360, fontSize: 12 };
const thStyle = { ...stdTh, padding: '7px 8px' };
const tdStyle = { padding: '7px 8px', borderBottom: '1px solid var(--bg-subtle)', verticalAlign: 'top', whiteSpace: 'nowrap' };
const emptyTd = { padding: 18, textAlign: 'center', color: 'var(--text-muted)', borderBottom: 'none' };
const linkBtn = { border: 'none', background: 'transparent', color: 'var(--std-accent-text, #1d7de6)', padding: 0, cursor: 'pointer', font: 'inherit', fontWeight: 800 };
// 배지 — 표준 배지 토큰 ('상세'=활성 파랑 / 출처=회색)
const sourceBadge = { ...stdBadgeMuted, fontSize: 11, padding: '2px 8px', whiteSpace: 'nowrap' };
const detailBadge = { ...stdBadgeActive, fontSize: 11, padding: '2px 8px', whiteSpace: 'nowrap' };
